/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Placement = z.enum([
  'LANDING',
  'EMAIL',
  'SURVEY',
  'TYP',
  'QUOTES',
]);

export type Placement = z.infer<typeof Placement>;
